// extracted by mini-css-extract-plugin
export default {"textClassName":"_2IG2v","circleClassName":"_2qSKk"};